import { useState, useEffect, useCallback } from 'react';

interface SharedData {
  unassigned: number[];
}
let sharedData: SharedData = { unassigned: [] };
const listeners = new Set<(data: SharedData) => void>();

export function useSharedData() {
  const [data, setData] = useState(sharedData);

  const updateData = useCallback((newData) => {
    sharedData = { ...sharedData, ...newData };
    listeners.forEach((listener) => listener(sharedData));
  }, []);

  useEffect(() => {
    const listener = (newData: SharedData) => {
      if (data !== newData) {
        setData(newData);
      }
    };
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  }, [data]);

  return { unassigned: data.unassigned, updateData };
}
